/*
 * Page purpose: Named motion presets for microanimations and object transitions.
 * Last modified: 2026-06-06 by Auto.
 * Completeness score: 92/100.
 */

export const motionPresets = {
  fade: {
    durationKey: "normal" as const,
    easingKey: "gentle" as const,
    properties: ["opacity"] as const,
  },
  slideUp: {
    durationKey: "normal" as const,
    easingKey: "gentle" as const,
    properties: ["opacity", "transform"] as const,
  },
  slideIn: {
    durationKey: "normal" as const,
    easingKey: "productive" as const,
    properties: ["opacity", "transform"] as const,
  },
  lift: {
    durationKey: "normal" as const,
    easingKey: "productive" as const,
    properties: ["transform", "box-shadow"] as const,
  },
  objectTransition: {
    durationKey: "normal" as const,
    easingKey: "productive" as const,
    properties: ["transform", "box-shadow", "background-color", "opacity"] as const,
  },
  press: {
    durationKey: "fast" as const,
    easingKey: "productive" as const,
    properties: ["transform"] as const,
  },
  chip: {
    durationKey: "fast" as const,
    easingKey: "productive" as const,
    properties: ["background-color", "color", "border-color", "transform"] as const,
  },
} as const;

export type MotionPresetKey = keyof typeof motionPresets;

/** CSS class map — apply in JSX or templates. */
export const motionClasses = {
  pageEnter: "ui-motion-page-enter",
  pageEnterHeader: "ui-motion-page-enter-header",
  pageEnterBody: "ui-motion-page-enter-body",
  staggerGrid: "ui-motion-stagger-grid",
  staggerList: "ui-motion-stagger-list",
  objectInteractive: "ui-motion-object-interactive",
  objectRow: "ui-motion-object-row",
  chip: "ui-motion-chip",
  button: "ui-motion-button",
  slideContent: "ui-motion-slide-content",
  expand: "ui-motion-expand",
} as const;
